// Environment configuration
export const config = {
  // Google OAuth Configuration
  google: {
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || "",
    clientSecret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET || "",
    redirectUri:
      process.env.REACT_APP_GOOGLE_REDIRECT_URI ||
      "http://localhost:3000/auth/callback",
  },

  // N8n Webhook Provider
  n8n: {
    apiKey: process.env.REACT_APP_N8N_API_KEY || "",
    getReferralByIdWebhookUrl:
      process.env.REACT_APP_N8N_GET_REFERRAL_BY_ID_WEBHOOK_URL || "",
    getReferralsWebhookUrl:
      process.env.REACT_APP_N8N_GET_REFERRALS_WEBHOOK_URL || "",
    saveReferralWebhookUrl:
      process.env.REACT_APP_N8N_SAVE_REFERRAL_WEBHOOK_URL || "",
  },

  // Surefyre Configuration
  surefyre: {
    getApplicationByIdUrl:
      process.env.REACT_APP_N8N_SUREFYRE_GET_APPLICATION_BY_ID || "",
    getDocumentsUrl: process.env.REACT_APP_N8N_SUREFYRE_GET_DOCUMENTS || "",
    getAttachmentsUrl: process.env.REACT_APP_N8N_SUREFYRE_GET_ATTACHMENTS || "",
    getAssignedRoleUrl:
      process.env.REACT_APP_N8N_SUREFYRE_GET_ASSIGNED_ROLE || "",
    getUserUrl: process.env.REACT_APP_N8N_SUREFYRE_GET_USER || "",
  },

  // Accelerant Configuration
  accelerant: {
    submitReferralUrl:
      process.env.REACT_APP_N8N_ACCELERANT_SUBMIT_REFERRAL || "",
    uploadAttachmentsUrl:
      process.env.REACT_APP_N8N_ACCELERANT_UPLOAD_ATTACHMENTS || "",
    getReferralUrl: process.env.REACT_APP_N8N_ACCELERANT_GET_REFERRAL || "",
    updateReferralUrl:
      process.env.REACT_APP_N8N_ACCELERANT_UPDATE_REFERRAL || "",
    fileProxyUrl: process.env.REACT_APP_N8N_FILE_PROXY_WEBHOOK_URL || "",
    getMemberProgramsUrl:
      process.env.REACT_APP_N8N_ACCELERANT_GET_MEMBER_PROGRAMS || "",
    getOrgUsersUrl: process.env.REACT_APP_N8N_ACCELERANT_GET_ORG_USERS || "",
    orgId: "ca90e8a7-322a-427a-aeb9-f91160d1fe36",
  },

  // Authentication
  auth: {
    allowedCompanyDomain: process.env.REACT_APP_ALLOWED_COMPANY_DOMAIN || "",
  },
};

// Validation function to check if required environment variables are set
export const validateConfig = (): {
  isValid: boolean;
  missingVars: string[];
} => {
  const requiredVars = [
    "REACT_APP_GOOGLE_CLIENT_ID",
    "REACT_APP_ALLOWED_COMPANY_DOMAIN",
    "REACT_APP_N8N_API_KEY",
    "REACT_APP_N8N_GET_REFERRAL_BY_ID_WEBHOOK_URL",
    "REACT_APP_N8N_GET_REFERRALS_WEBHOOK_URL",
    "REACT_APP_N8N_SAVE_REFERRAL_WEBHOOK_URL",
    "REACT_APP_N8N_SUREFYRE_GET_APPLICATION_BY_ID",
    "REACT_APP_N8N_SUREFYRE_GET_DOCUMENTS",
    "REACT_APP_N8N_SUREFYRE_GET_ATTACHMENTS",
    "REACT_APP_N8N_SUREFYRE_GET_ASSIGNED_ROLE",
    "REACT_APP_N8N_SUREFYRE_GET_USER",
    "REACT_APP_N8N_ACCELERANT_SUBMIT_REFERRAL",
    "REACT_APP_N8N_ACCELERANT_UPLOAD_ATTACHMENTS",
    "REACT_APP_N8N_ACCELERANT_GET_REFERRAL",
    "REACT_APP_N8N_ACCELERANT_UPDATE_REFERRAL",
    "REACT_APP_N8N_FILE_PROXY_WEBHOOK_URL",
    "REACT_APP_N8N_ACCELERANT_GET_MEMBER_PROGRAMS",
    "REACT_APP_N8N_ACCELERANT_GET_ORG_USERS",
  ];

  // Optional but recommended vars for full functionality
  const missingVars = requiredVars.filter((varName) => !process.env[varName]);

  if (missingVars.length > 0) {
    console.info("Required environment variables not set:", missingVars);
  }

  return {
    isValid: missingVars.length === 0,
    missingVars,
  };
};

export default config;
